import React, { Component } from 'react';
import { mediaUrl } from './PhotosRest';

export default class StripImage extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    parent: props.parent,
	    media: props.media
	};
    }

    componentDidMount() {
	this.props.scroll();
    }

    componentDidUpdate() {
	this.props.scroll();
    }

    choose = () => this.state.parent.choose(this.state.media);

    render() {
	return (<img className='stripImage'
		id={this.props.chosen ? 'chosen' : 'normal'}
		src={mediaUrl(1, this.props.media)}
		onClick={this.choose}
		alt=""
		key={this.state.media}
		/>);
    }
}
